// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cE_sqJuLlDacntOImPq4 {
  display: block;
  font-size: 14px;
  color: var(--sl-fg-base, #1f1f1f);
  max-width: 28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  text-underline-offset: 2px;
  transition: color 150ms;
  border-radius: 2px;
}

.cE_sqJuLlDacntOImPq4:hover {
  text-decoration: underline;
  color: var(--sl-fg-base-soft, #707070);
}

.cE_sqJuLlDacntOImPq4:focus {
  outline: 2px solid rgba(3, 102, 221, 0.3);
  outline-offset: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/pages/campaigns/spend-reports/styles.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB","sourcesContent":[".campaignLink {\n  display: block;\n  font-size: 14px;\n  color: var(--sl-fg-base, #1f1f1f);\n  max-width: 28rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-decoration: none;\n  text-underline-offset: 2px;\n  transition: color 150ms;\n  border-radius: 2px;\n}\n\n.campaignLink:hover {\n  text-decoration: underline;\n  color: var(--sl-fg-base-soft, #707070);\n}\n\n.campaignLink:focus {\n  outline: 2px solid rgba(3, 102, 221, 0.3);\n  outline-offset: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignLink": `cE_sqJuLlDacntOImPq4`
};
export default ___CSS_LOADER_EXPORT___;
